import Autocomplete from 'react-google-autocomplete'
import React, { useRef } from 'react'
import { useFormContext } from '../FormProvider'

const GoogleLocation = () => {
  const googlePlaceAutoCompleteRef = useRef(null)
  const { formData, setFormData, errors } = useFormContext()
  return (
    <div
      className={`Category_name Location_values ${
        errors.VenueAddress ? 'invalid' : 'valid'
      }`}
      style={{ marginBottom: '20px', width: '100%' }}
    >
      <div className='venue-address' style={{ paddingTop: '7px' }}>
        <Autocomplete
          apiKey='AIzaSyCmcI0swO1MNjQYUD7qktNT78-cDMBoi44'
          onPlaceSelected={place => {
            setFormData(prevForm => ({
              ...prevForm,
              latitude: place.geometry.location.lat()
            }))
            setFormData(prevForm => ({
              ...prevForm,
              longitude: place.geometry.location.lng()
            }))
            setFormData(prevForm => ({
              ...prevForm,
              VenueAddress: place.formatted_address
            }))
          }}
          onPaste={e => {
            e.preventDefault()
          }}
          onChange={e =>
            setFormData(prevForm => ({
              ...prevForm,
              VenueAddress: e.target.value
            }))
          }
          defaultValue={formData.VenueAddress}
          placeholder='Venue Address'
          className='fontSize16'
          options={{
            types: ['geocode', 'establishment']
          }}
          ref={googlePlaceAutoCompleteRef}
        />
      </div>
    </div>
  )
}
export default GoogleLocation
